import React, { useState, useEffect } from 'react';
import { getUsuarios, cambiarRol, eliminarUsuario, crearUsuarioManual, getComunidades, cambiarPassword, updateUsuario, toggleFichajesPermiso, hacerSuperadmin } from '../services/api';
import { useToast } from '../components/Toast';
import Pagination from '../components/Pagination';
import ConfirmModal from '../components/ConfirmModal';

function Usuarios({ user }) {
  const toast = useToast();
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]);
  const [comunidades, setComunidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordUser, setPasswordUser] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [filtroComunidad, setFiltroComunidad] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editUsuario, setEditUsuario] = useState(null);
  const [confirmModal, setConfirmModal] = useState({ isOpen: false, title: '', message: '', onConfirm: null, confirmLabel: 'Eliminar', variant: 'danger' });
  const [nuevoUsuario, setNuevoUsuario] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    password: 'cambiar123',
    rol: '',
    comunidad_id: '',
    piso: '',
    telefono: ''
  });

  useEffect(() => {
    cargarUsuarios();
    cargarComunidades();
  }, []);

  useEffect(() => {
    aplicarFiltros();
  }, [usuarios, busqueda, filtroComunidad]);

  const aplicarFiltros = () => {
    let resultado = usuarios;

    if (filtroComunidad) {
      resultado = resultado.filter(u => String(u.comunidad_id) === String(filtroComunidad));
    }

    if (busqueda) {
      const busq = busqueda.toLowerCase();
      resultado = resultado.filter(u =>
        u.nombre?.toLowerCase().includes(busq) ||
        u.apellidos?.toLowerCase().includes(busq) ||
        u.email?.toLowerCase().includes(busq) ||
        u.piso?.toLowerCase().includes(busq) ||
        u.comunidad_nombre?.toLowerCase().includes(busq)
      );
    }

    setUsuariosFiltrados(resultado);
    setCurrentPage(1);
  };

  const cargarUsuarios = async () => {
    try {
      const response = await getUsuarios();
      setUsuarios(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const cargarComunidades = async () => {
    try {
      const response = await getComunidades();
      setComunidades(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleCambiarRol = async (id, nuevoRol, usuarioObj) => {
    if (nuevoRol === 'superadmin') {
      openConfirm(
        'Hacer superadministrador',
        `¿Confirmas que quieres dar acceso de Superadministrador a ${usuarioObj?.nombre || ''}? Tendrá acceso completo a todas las comunidades.`,
        async () => {
          closeConfirm();
          try {
            await hacerSuperadmin(id);
            toast.success(`${usuarioObj?.nombre || 'Usuario'} ahora es superadministrador`);
            cargarUsuarios();
          } catch (error) {
            toast.error(error.response?.data?.error || 'Error al cambiar permisos');
          }
        },
        'Confirmar',
        'primary'
      );
      return;
    }
    try {
      await cambiarRol(id, nuevoRol);
      toast.success('Rol cambiado con éxito');
      cargarUsuarios();
    } catch (error) {
      toast.error('Error al cambiar rol');
    }
  };

  const handleHacerSuperadmin = (usuario) => {
    openConfirm(
      'Hacer superadmin',
      `¿Confirmas que quieres dar acceso de SUPERADMIN a ${usuario.nombre} ${usuario.apellidos || ''}? Tendrá acceso completo a todas las comunidades y funciones de administración.`,
      async () => {
        closeConfirm();
        try {
          await hacerSuperadmin(usuario.id);
          toast.success(`${usuario.nombre} ahora es superadmin`);
          cargarUsuarios();
        } catch (error) {
          toast.error(error.response?.data?.error || 'Error al cambiar permisos');
        }
      }
    );
  };

  const openConfirm = (title, message, onConfirm, confirmLabel = 'Eliminar', variant = 'danger') => {
    setConfirmModal({ isOpen: true, title, message, onConfirm, confirmLabel, variant });
  };
  const closeConfirm = () => setConfirmModal(prev => ({ ...prev, isOpen: false }));

  const handleEliminar = (id) => {
    openConfirm(
      'Eliminar usuario',
      '⚠️ ¿Estás seguro de eliminar este usuario PERMANENTEMENTE? Esta acción no se puede deshacer.',
      async () => {
        closeConfirm();
        try {
          await eliminarUsuario(id);
          toast.success('Usuario eliminado con éxito');
          cargarUsuarios();
        } catch (error) {
          toast.error(error.response?.data?.error || 'Error al eliminar usuario');
        }
      }
    );
  };

  const handleToggleFichajesPermiso = async (usuario) => {
    const nuevoValor = !usuario.puede_gestionar_fichajes;
    try {
      await toggleFichajesPermiso(usuario.id, nuevoValor);
      toast.success(nuevoValor ? `${usuario.nombre} puede ver todos los fichajes` : `Permiso de fichajes retirado a ${usuario.nombre}`);
      cargarUsuarios();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al cambiar permiso');
    }
  };

  const handleCambiarPassword = async () => {
    if (!newPassword || newPassword.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    try {
      await cambiarPassword(passwordUser.id, newPassword);
      toast.success(`Contraseña de ${passwordUser.nombre} actualizada`);
      setShowPasswordModal(false);
      setPasswordUser(null);
      setNewPassword('');
      setShowPassword(false);
      cargarUsuarios();
    } catch (error) {
      toast.error('Error: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleCrearUsuario = async (e) => {
    e.preventDefault();
    try {
      await crearUsuarioManual(nuevoUsuario);
      setShowModal(false);
      setNuevoUsuario({
        nombre: '',
        apellidos: '',
        email: '',
        password: 'cambiar123',
        rol: '',
        comunidad_id: '',
        piso: '',
        telefono: ''
      });
      cargarUsuarios();
      toast.success('Usuario creado con éxito');
    } catch (error) {
      toast.error('Error al crear usuario: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleEditarUsuario = async (e) => {
    e.preventDefault();
    try {
      await updateUsuario(editUsuario.id, editUsuario);
      setShowEditModal(false);
      setEditUsuario(null);
      cargarUsuarios();
      toast.success('Usuario actualizado con éxito');
    } catch (error) {
      toast.error('Error al actualizar: ' + (error.response?.data?.error || error.message));
    }
  };

  const abrirEditModal = (usuario) => {
    setEditUsuario({
      id: usuario.id,
      nombre: usuario.nombre || '',
      apellidos: usuario.apellidos || '',
      email: usuario.email || '',
      piso: usuario.piso || '',
      telefono: usuario.telefono || '',
      comunidad_id: usuario.comunidad_id || '',
      rol: usuario.rol || 'vecino'
    });
    setShowEditModal(true);
  };

  const totalPages = Math.ceil(usuariosFiltrados.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const usuariosPaginados = usuariosFiltrados.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="container" style={{ paddingTop: '40px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '12px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700' }}>👥 Gestión de Usuarios</h1>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <select
            className="form-control"
            value={filtroComunidad}
            onChange={(e) => setFiltroComunidad(e.target.value)}
            style={{ minWidth: '160px', fontSize: '14px', height: '40px' }}
          >
            <option value="">Todas las comunidades</option>
            {comunidades.map(com => (
              <option key={com.id} value={com.id}>{com.nombre}</option>
            ))}
          </select>
          <button onClick={() => setShowModal(true)} className="btn btn-primary">
            + Crear Usuario
          </button>
        </div>
      </div>
      
      {loading ? (
        <div className="loading"><div className="spinner"></div></div>
      ) : (
        <>
          {/* Barra de búsqueda */}
          <div className="card" style={{ marginBottom: '20px', padding: '16px' }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <input
                type="text"
                className="form-control"
                placeholder="🔍 Buscar usuario por nombre, email, comunidad, piso..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                style={{ fontSize: '14px' }}
              />
              {busqueda && (
                <small style={{ color: 'var(--text-secondary)', marginTop: '8px', display: 'block' }}>
                  Mostrando {usuariosFiltrados.length} de {usuarios.length} usuarios
                </small>
              )}
            </div>
          </div>

          <div className="card" style={{ padding: '16px', overflowX: 'auto' }}>
            <div className="table-responsive">
            <table className="table" style={{ width: '100%', tableLayout: 'fixed', minWidth: '800px' }}>
              <thead>
                <tr>
                  <th style={{ width: '18%' }}>Nombre</th>
                  <th style={{ width: '20%' }}>Email</th>
                  <th style={{ width: '15%' }}>Comunidad</th>
                  <th style={{ width: '7%' }}>Piso</th>
                  <th style={{ width: '12%' }}>Teléfono</th>
                  <th style={{ width: '12%' }}>Rol</th>
                  <th style={{ width: '16%', textAlign: 'right' }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {usuariosPaginados.map(usuario => (
                <tr key={usuario.id}>
                  <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={`${usuario.nombre} ${usuario.apellidos}`}>
                    {usuario.nombre} {usuario.apellidos}
                  </td>
                  <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={usuario.email}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{usuario.email}</span>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(usuario.email);
                          toast.success('Email copiado al portapapeles');
                        }}
                        className="btn btn-sm"
                        style={{ padding: '4px 8px', fontSize: '12px', minWidth: 'auto' }}
                        title="Copiar email"
                      >
                        📋
                      </button>
                    </div>
                  </td>
                  <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={usuario.comunidad_nombre || 'Sin comunidad'}>
                    {usuario.comunidad_nombre || <span style={{ color: 'var(--text-secondary)' }}>—</span>}
                  </td>
                  <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={usuario.piso}>{usuario.piso || '-'}</td>
                  <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={usuario.telefono}>
                    {usuario.telefono || '-'}
                  </td>
                  <td>
                    <select
                      className="form-control"
                      style={{ padding: '6px 10px', fontSize: '13px', width: '100%', minWidth: '130px' }}
                      value={usuario.is_superadmin ? 'superadmin' : usuario.rol}
                      onChange={(e) => handleCambiarRol(usuario.id, e.target.value, usuario)}
                    >
                      <option value="vecino">Vecino</option>
                      <option value="administrador">Administrador</option>
                      {user?.is_superadmin && <option value="superadmin">Superadministrador</option>}
                      <option value="presidente">Presidente</option>
                      <option value="proveedor">Proveedor</option>
                      <option value="conserje">Conserje</option>
                    </select>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <div style={{ display: 'flex', gap: '4px', justifyContent: 'flex-end' }}>
                      <button
                        onClick={() => abrirEditModal(usuario)}
                        className="btn btn-sm btn-outline"
                        style={{ whiteSpace: 'nowrap' }}
                        title="Editar usuario"
                      >
                        ✏️
                      </button>
                      <button
                        onClick={() => {
                          setPasswordUser(usuario);
                          setNewPassword('');
                          setShowPassword(false);
                          setShowPasswordModal(true);
                        }}
                        className="btn btn-sm btn-outline"
                        style={{ whiteSpace: 'nowrap' }}
                        title="Cambiar contraseña"
                      >
                        🔑
                      </button>
                      {user?.is_superadmin && (
                        <button
                          onClick={() => handleToggleFichajesPermiso(usuario)}
                          className="btn btn-sm btn-outline"
                          style={{
                            whiteSpace: 'nowrap',
                            background: usuario.puede_gestionar_fichajes ? '#dbeafe' : '',
                            borderColor: usuario.puede_gestionar_fichajes ? '#2563eb' : '',
                            color: usuario.puede_gestionar_fichajes ? '#1d4ed8' : ''
                          }}
                          title={usuario.puede_gestionar_fichajes ? 'Quitar acceso a fichajes de todos' : 'Dar acceso a fichajes de todos'}
                        >
                          ⏱️
                        </button>
                      )}
                      <button
                        onClick={() => handleEliminar(usuario.id)}
                        className="btn btn-sm btn-danger"
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          totalItems={usuariosFiltrados.length}
          onPageChange={setCurrentPage}
          onItemsPerPageChange={setItemsPerPage}
        />
      </>
      )}

      {/* Modal para crear usuario */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingTop: '70px',
          paddingBottom: '20px',
          zIndex: 2000,
          overflowY: 'auto'
        }} onClick={() => setShowModal(false)}>
          <div className="card" style={{
            maxWidth: '600px',
            width: '90%',
            flexShrink: 0
          }} onClick={(e) => e.stopPropagation()}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '20px' }}>Crear Nuevo Usuario</h2>

            <form onSubmit={handleCrearUsuario}>
              <div className="form-group">
                <label className="form-label">Nombre *</label>
                <input
                  type="text"
                  className="form-control"
                  value={nuevoUsuario.nombre}
                  onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, nombre: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Apellidos</label>
                <input
                  type="text"
                  className="form-control"
                  value={nuevoUsuario.apellidos}
                  onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, apellidos: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  className="form-control"
                  value={nuevoUsuario.email}
                  onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, email: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Contraseña (predeterminada: cambiar123)</label>
                <input
                  type="text"
                  className="form-control"
                  value={nuevoUsuario.password}
                  onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, password: e.target.value })}
                />
              </div>

              <div className="grid grid-2">
                <div className="form-group">
                  <label className="form-label">Rol *</label>
                  <select
                    className="form-control"
                    value={nuevoUsuario.rol}
                    onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, rol: e.target.value })}
                    required
                  >
                    <option value="">Seleccionar...</option>
                    <option value="vecino">Vecino</option>
                    <option value="administrador">Administrador</option>
                    <option value="presidente">Presidente</option>
                    <option value="proveedor">Proveedor</option>
                    <option value="conserje">Conserje</option>
                  </select>
                </div>

                {nuevoUsuario.rol !== 'administrador' && (
                  <div className="form-group">
                    <label className="form-label">Comunidad *</label>
                    <select
                      className="form-control"
                      value={nuevoUsuario.comunidad_id}
                      onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, comunidad_id: e.target.value })}
                      required
                    >
                      <option value="">Seleccionar...</option>
                      {comunidades.map(com => (
                        <option key={com.id} value={com.id}>{com.nombre}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              <div className="grid grid-2">
                <div className="form-group">
                  <label className="form-label">Piso *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={nuevoUsuario.piso}
                    onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, piso: e.target.value })}
                    placeholder="Ej: 3º A"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Teléfono</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={nuevoUsuario.telefono}
                    onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, telefono: e.target.value })}
                    placeholder="Ej: 600123456"
                  />
                </div>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button type="button" onClick={() => setShowModal(false)} className="btn btn-outline">
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Crear Usuario
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Modal cambiar contraseña */}
      {showPasswordModal && passwordUser && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingTop: '70px',
          paddingBottom: '20px',
          zIndex: 2000,
          overflowY: 'auto'
        }} onClick={() => setShowPasswordModal(false)}>
          <div className="card" style={{
            maxWidth: '450px',
            width: '90%',
            flexShrink: 0
          }} onClick={(e) => e.stopPropagation()}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>
              🔑 Contraseña de Usuario
            </h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '20px' }}>
              <strong>{passwordUser.nombre} {passwordUser.apellidos}</strong> ({passwordUser.email})
            </p>

            <div className="form-group">
              <label className="form-label">Nueva contraseña</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  style={{ paddingRight: '45px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '16px',
                    padding: '4px'
                  }}
                >
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
              {newPassword && newPassword.length < 6 && (
                <small style={{ color: '#ef4444', fontSize: '12px' }}>Mínimo 6 caracteres</small>
              )}
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button
                type="button"
                onClick={() => setShowPasswordModal(false)}
                className="btn btn-outline"
              >
                Cerrar
              </button>
              <button
                onClick={handleCambiarPassword}
                className="btn btn-primary"
                disabled={!newPassword || newPassword.length < 6}
              >
                Guardar Contraseña
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Modal editar usuario */}
      {showEditModal && editUsuario && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingTop: '70px',
          paddingBottom: '20px',
          zIndex: 2000,
          overflowY: 'auto'
        }} onClick={() => setShowEditModal(false)}>
          <div className="card" style={{
            maxWidth: '600px',
            width: '90%',
            flexShrink: 0
          }} onClick={(e) => e.stopPropagation()}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '20px' }}>
              Editar Usuario
            </h2>

            <form onSubmit={handleEditarUsuario}>
              <div className="form-group">
                <label className="form-label">Nombre *</label>
                <input
                  type="text"
                  className="form-control"
                  value={editUsuario.nombre}
                  onChange={(e) => setEditUsuario({ ...editUsuario, nombre: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Apellidos</label>
                <input
                  type="text"
                  className="form-control"
                  value={editUsuario.apellidos}
                  onChange={(e) => setEditUsuario({ ...editUsuario, apellidos: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  className="form-control"
                  value={editUsuario.email}
                  onChange={(e) => setEditUsuario({ ...editUsuario, email: e.target.value })}
                  required
                />
              </div>

              <div className="grid grid-2">
                <div className="form-group">
                  <label className="form-label">Rol *</label>
                  <select
                    className="form-control"
                    value={editUsuario.rol}
                    onChange={(e) => setEditUsuario({ ...editUsuario, rol: e.target.value })}
                    required
                  >
                    <option value="vecino">Vecino</option>
                    <option value="administrador">Administrador</option>
                    <option value="presidente">Presidente</option>
                    <option value="proveedor">Proveedor</option>
                    <option value="conserje">Conserje</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Comunidad *</label>
                  <select
                    className="form-control"
                    value={editUsuario.comunidad_id}
                    onChange={(e) => setEditUsuario({ ...editUsuario, comunidad_id: e.target.value })}
                    required
                  >
                    <option value="">Seleccionar...</option>
                    {comunidades.map(com => (
                      <option key={com.id} value={com.id}>{com.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="grid grid-2">
                <div className="form-group">
                  <label className="form-label">Piso</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editUsuario.piso}
                    onChange={(e) => setEditUsuario({ ...editUsuario, piso: e.target.value })}
                    placeholder="Ej: 3º A"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Teléfono</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={editUsuario.telefono}
                    onChange={(e) => setEditUsuario({ ...editUsuario, telefono: e.target.value })}
                    placeholder="Ej: 600123456"
                  />
                </div>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button type="button" onClick={() => setShowEditModal(false)} className="btn btn-outline">
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Guardar Cambios
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onCancel={closeConfirm}
        confirmLabel={confirmModal.confirmLabel}
        variant={confirmModal.variant}
      />
    </div>
  );
}

export default Usuarios;
